import { TermsInfo } from '../../data-types/initialisation/initialisationInterfaces';
import { AcceptedCountries, AvailableLanguage } from '../../data-types/international/internationalEnums';
import { UserQuestionsTypes } from '../../data-types/user/userEnums';
import { ProofRequest, User, UserAchievement } from '../../data-types/user/userInterfaces';
import { store } from '../store';
import {
  CLEAR_USER_DETAILS,
  SET_AUTHENTICATION,
  SET_GEO_LOCATION,
  SET_INBOX_BADGE,
  SET_LOADING_ACHIEVEMENTS,
  SET_LOCALE,
  SET_PENDING_QUESTIONS,
  SET_PROOF_REQUESTS,
  SET_SAFER_GAMBLING_QUESTIONS_SET,
  SET_SELECTED_PROOF_REQUEST,
  SET_TERMS_INFO,
  SET_USER_ACHIEVEMENTS,
  SET_USER_ACHIEVEMENTS_UPDATED,
  SET_USER_DETAILS,
  SET_USER_LOCATION,
} from '../types/userDataTypes';
import { setRealityCheckDialog } from './dialogActions';

export const setUserDetails = (user: User) => {
  store.dispatch({
    type: SET_USER_DETAILS,
    meta: { ...store.getState().userData.user, ...user },
  });
};

export const clearUserDetails = () => {
  store.dispatch({
    type: CLEAR_USER_DETAILS,
    meta: {},
  });
};

export const setAuthentication = (level: number) => {
  setRealityCheckDialog(false);
  store.dispatch({
    type: SET_AUTHENTICATION,
    meta: {
      authentication: level,
    },
  });
};

export const setTermsInfo = (terms: TermsInfo | undefined) => {
  store.dispatch({
    type: SET_TERMS_INFO,
    meta: terms,
  });
};

export const setLocale = (meta: AvailableLanguage) => {
  store.dispatch({
    meta,
    type: SET_LOCALE,
  });
};

export const setUserLocation = (meta: AcceptedCountries) => {
  store.dispatch({
    meta,
    type: SET_USER_LOCATION,
  });
};

export const setGeoLocalisation = (meta: string) => {
  store.dispatch({
    meta,
    type: SET_GEO_LOCATION,
  });
};

export const setInboxBadge = (meta: number) => {
  store.dispatch({
    meta,
    type: SET_INBOX_BADGE,
  });
};

export const setProofRequests = (meta: ProofRequest[]) => {
  store.dispatch({
    meta,
    type: SET_PROOF_REQUESTS,
  });
};

export const setSelectedProofRequest = (meta: ProofRequest | undefined) => {
  store.dispatch({
    meta,
    type: SET_SELECTED_PROOF_REQUEST,
  });
};

export const setPendingQuestions = (meta: boolean) => {
  store.dispatch({
    meta,
    type: SET_PENDING_QUESTIONS,
  });
};

export const setUserAchievements = (meta: UserAchievement[]) => {
  store.dispatch({
    meta,
    type: SET_USER_ACHIEVEMENTS,
  });
};

export const setUserAchievementsUpdated = (meta: boolean) => {
  store.dispatch({
    meta,
    type: SET_USER_ACHIEVEMENTS_UPDATED,
  });
};

export const setLoadingAchievements = (meta: boolean) => {
  store.dispatch({
    meta,
    type: SET_LOADING_ACHIEVEMENTS,
  });
};

export const setSaferGamblingQuestionsSetType = (meta: UserQuestionsTypes | undefined) => {
  store.dispatch({
    meta,
    type: SET_SAFER_GAMBLING_QUESTIONS_SET,
  });
};
